import React from "react";
import { Home } from "../pages/Home";
import { PrivateRoute } from "./privateRoute";
import { Routes as Switch, Route, Navigate } from "react-router-dom";
import { ReservationsListRoot } from "../pages/ROOT/Reservations";
import { AccommodationsListRoot } from "../pages/ROOT/Accommodations";
import { BusinessListRoot } from "../pages/ROOT/Business";
import { PlansRoot } from "../pages/ROOT/Plans";
import GuestPdf from "../pages/GuestPdf";
import { SubscriptionRoot } from "../pages/ROOT/Subscription";
import { DashboardRoot } from "../pages/ROOT/Dashboard";
import { NotificationRulesListRoot } from "../pages/ROOT/NotificationRules";
import { MessageModelsRoot } from "../pages/ROOT/MessageModels";
import { GeneralSettingsDefault } from "../pages/ROOT/GeneralSettings";
import ContractReservationPdf from "../pages/ContractReservationPdf";
import { UsersRemarketingRoot } from "../pages/ROOT/UsersRemarketing";

export const RootRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path="" element={<PrivateRoute />}>
        <Route index element={<DashboardRoot />} />
      </Route>

      <Route path="dashboard" element={<PrivateRoute />}>
        <Route index element={<DashboardRoot />} />
      </Route>

      <Route path="business" element={<PrivateRoute />}>
          <Route index element={<BusinessListRoot />} />
        </Route>

      <Route path="users-remarketing" element={<PrivateRoute />}>
        <Route index element={<UsersRemarketingRoot />} />
      </Route>

      <Route path="settings" element={<PrivateRoute />}>
        <Route index element={<Navigate to="/" />} />
        <Route path="general-default" element={<GeneralSettingsDefault />} />
        <Route path="notification-rules-default" element={<NotificationRulesListRoot />} />
        <Route path="message-models-default" element={<MessageModelsRoot />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>

      <Route path="accommodations" element={<PrivateRoute />}>
        <Route index element={<AccommodationsListRoot />} />
      </Route>

      <Route path="reservations" element={<PrivateRoute />}>
        <Route index element={<ReservationsListRoot />} />
      </Route>
      <Route path="guest-registration-pdf" element={<GuestPdf />} />

      <Route path="contract-reservation" element={<ContractReservationPdf />} />

      <Route path="subscription" element={<PrivateRoute />}>
        <Route index element={<SubscriptionRoot />} />
      </Route>

      <Route path="plans" element={<PrivateRoute />}>
        <Route index element={<PlansRoot />} />
      </Route>


      <Route path="*" element={<Navigate to="" />} />
    </Switch>
  );
};
